import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row } from 'react-bootstrap';
import map from 'lodash/map';
import { useTranslation } from 'react-i18next';

import { LoadingStatusWrapper } from 'sharedComponents/WithLoadingStatus';

import { Header } from './Header';
import AssetDetailsList from './AssetDetailsList';

import './style.scss';

const AssetDetailsComponent = ({
    asset,
    isUnmonitored,
    model: {
        assetDetails: {
            details,
            sections,
            loadingStatus,
            isDriveTypeChanged
        },
    }

}) => {
    const { t: translate } = useTranslation();

    const filterPopulatedItems = (data) => {
        if (!isUnmonitored) {
            return data;
        }
        return data?.filter(({ value }) => value !== null && value !== undefined && value !== '' && value !== '-');
    };

    const filteredDetails = filterPopulatedItems(details);
    const filteredSections = sections
        ?.map(section => ({ ...section, data: filterPopulatedItems(section.data) }))
        ?.filter(section => section.data?.length);

    return (
        <Container fluid id='asset-details-container'>
            <Row><Header asset={asset} /></Row>

            <div className='asset-details-component'>
                <LoadingStatusWrapper loadingStatus={loadingStatus} >
                    <div className='asset-detail-lists-container'>
                        {filteredDetails?.length ? <AssetDetailsList title={translate('ABB.Powertrain.Frontend.assetDetailsAssetDataTitle')} data={filteredDetails} /> : null}
                    </div>
                    <div className='asset-detail-lists-container'>
                        {
                            map(filteredSections, (section) => {
                                return section.data.length ? <AssetDetailsList key={section.sectionName} title={translate(section.label)} data={section.data} isDriveTypeChanged={isDriveTypeChanged} /> : null;
                            })
                        }
                    </div>
                </LoadingStatusWrapper>
            </div>
        </Container>
    );
};

AssetDetailsComponent.propTypes = {
    asset: PropTypes.object,
    isUnmonitored: PropTypes.bool,
    model: PropTypes.shape({
        assetDetails: PropTypes.shape({
            details: PropTypes.array,
            sections: PropTypes.array,
            loadingStatus: PropTypes.string,
            isDriveTypeChanged: PropTypes.bool,
        }),
    }),
};

export default AssetDetailsComponent;
